import {isSameDay} from 'date-fns';
import {getStartOfDay} from '@lib/utils';
import {ParkingReservation} from '../entities';

export enum ParkingReservationErrors {
  ParkingLastSpotReservedError = 'OfficeShifts_NodeOverReservationLimit_Format',
}

export const findParkingReservationByDate = (parkingReservations: ParkingReservation[], date: string) => {
  if (!date) return undefined;
  return parkingReservations.find((dateParkingReservation) =>
    isSameDay(getStartOfDay(dateParkingReservation.date), getStartOfDay(date)),
  );
};
